// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  QUES_STORE_UPDATE_CHECK_PARS_INDEX,
} from './constants';

export function updateCheckParsIndex({ payload }) {
  return {
    type: QUES_STORE_UPDATE_CHECK_PARS_INDEX,
    payload,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case QUES_STORE_UPDATE_CHECK_PARS_INDEX:
      return {
        ...state,
        checkParsIndex: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ques-store/redux/updateCheckParsIndex.js